import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Modal as AntModal, Avatar, message, Space } from "antd";
import { IconPublish } from "@assets";
import { getFormattedNumber } from "../../../../utils";
import { IconDomainName } from "../../../../assets/icons";
import { PRIVATE_ROUTE } from "../../../../route.constants";
import api from "../../../../api/api";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-title {
    text-align: center;
    font-size: 24px;
    color: #1e1e1e;
  }

  .ant-space-horizontal {
    gap: 16px;
    align-items: flex-start;
  }

  .ant-avatar.ant-avatar-square {
    border-radius: 8px !important;
  }

  .ant-modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    .ant-btn {
      flex: 0.5;
      width: 100%;
      height: 56px;
    }
  }
`;

const InfoText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #1e1e1e;
  text-align: center;
`;

const TitleText = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #1e1e1e;
  text-align: left;
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #7a7a7a;
  text-align: left;
`;

const Card = styled.div`
  padding: 24px;
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 4px 16px 0px color(display-p3 0 0 0 / 0.1);
`;

const Box = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 24px;
  background-color: ${(props) => props.theme.backgroundColor};
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.primaryColor};
  cursor: pointer;
`;

const FeeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > div:first-child {
    flex: 1;
    font-size: 16px;
    font-weight: 400;
    color: #1e1e1e;
  }

  > div:last-child {
    font-size: 22px;
    font-weight: 600;
    color: #1e1e1e;
  }
`;

const PaidText = styled.p`
  font-size: 16px;
  color: #1e1e1e;
  font-weight: 600;
  text-align: center;
`;

const PublishModal = ({
  seo_info,
  hosting_fee,
  domain_name,
  open,
  handleClose,
}) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const { HOME, TEMPLATE_MGNT, EDIT_TEMPLATE, PAY_HOSTING_FEE } = PRIVATE_ROUTE;
  const [hostingFee, setHostingFee] = React.useState({});

  const navigate = useNavigate();

  const {t} = useTranslation();

  useEffect(() => {
    getPanelInfo();
    checkHostingFee();
    // eslint-disable-next-line
  }, []);
  const getPanelInfo = () => {
    api
      .getPanelInfo()
      .then(({ data }) => {
        setData(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };
  const onOk = () => {
    if (!loading && !hosting_fee?.toPay) {
      setLoading(true);
      api
        .publishStore()
        .then(() => {
          setLoading(false);
          message.success(t('publish_success'));
          handleClose();
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    } else {
      // window.open(
      //   `/${HOME}/${TEMPLATE_MGNT}/${EDIT_TEMPLATE}/${PAY_HOSTING_FEE}`
      // );
      navigate(`/${HOME}/${TEMPLATE_MGNT}/${EDIT_TEMPLATE}/${PAY_HOSTING_FEE}`);
      handleClose();
    }
  };

  const onCancel = () => {
    !loading && handleClose();
  };

  const checkHostingFee = async (custom_domain) => {
    return api
      .checkHostingFee({ custom_domain })
      .then(({ data }) => {
        setHostingFee({
          hostingFeeData: data?.store,
        });
      })
      .catch((error) => {
        message.error(error);
      });
  };

  return (
    <Modal
      centered
      open={open}
      width={800}
      onCancel={onCancel}
      onOk={onOk}
      okText={hosting_fee?.toPay ? t('process_payment') : t('publish_mow')}
      confirmLoading={loading}
      title={
        <>
          <IconPublish />
          <div>{t('ready_store')}</div>
        </>
      }
    >
      <InfoText>
       {t('ready_store_text')}
      </InfoText>
      <Card>
        <Space>
          <Avatar shape="square" size={160} src={seo_info?.image} />
          <Space direction="vertical">
            <TitleText>{seo_info?.seo_title}</TitleText>
            <Text>{seo_info?.seo_description}</Text>
          </Space>
        </Space>
        <Box>
          <IconDomainName />
          <div onClick={() => window.open(domain_name)}>{domain_name}</div>
        </Box>
        {hostingFee?.hostingFeeData?.hosting_billing_status === "PAID" ? (
          <PaidText>
            {t('hosting_fee')}
            {getFormattedNumber(parseFloat(hosting_fee?.amount))} {t('is_ready_paid')}{" "}
            {moment(hostingFee?.hostingFeeData?.hosting_fee_end_date).format(
              "DD MMM, YYYY"
            )}
          </PaidText>
        ) : (
          <FeeWrapper>
            <div>{t('store_hosting_fee')}</div>
            <div>${getFormattedNumber(parseFloat(hosting_fee?.amount))}</div>
          </FeeWrapper>
        )}
      </Card>
    </Modal>
  );
};

export default PublishModal;
